'use client'

import React from 'react'
import { SitemapItem } from 'src/cms/elasticsearch/types'
import { buildCategoryTree } from 'src/screens/Sitemap/utils/buildCategoryTree'
import { CategoryTree } from 'src/screens/Sitemap/categoryTree'

interface SitemapProps {
  categories: SitemapItem[]
}

export const Sitemap = ({ categories }: SitemapProps) => {
  const categoryTree = buildCategoryTree(categories)

  return (
    <div className={'w-full max-w-[1336px] mx-auto px-5 py-10'}>
      <header className={'mb-8'}>
        <h1 className={'text-3xl font-bold text-gray-900 mb-2'}>Harta site</h1>
        <p className={'text-gray-600'}>
          Navigați prin structura completă a site-ului Consiliului Național al Audiovizualului.
        </p>
      </header>

      <section
        aria-labelledby={'sitemap-content-heading'}
        className={'bg-white rounded-lg shadow-sm border border-gray-200 p-8'}>
        <h2 id={'sitemap-content-heading'} className={'text-2xl font-semibold text-gray-900 mb-6'}>
          Conținut
        </h2>

        {categoryTree.length > 0 ? (
          <CategoryTree categories={categoryTree} />
        ) : (
          <p className={'text-gray-500 italic'}>Nu există categorii disponibile momentan.</p>
        )}
      </section>
    </div>
  )
}
